<div class="expansion-toggle expanded">
  @if (oneLineHeader) {
    <h3>
      {{ 'summary.receipt' | translate }}
      <span class="chargepoint">{{ chargePoint$()?.name }} </span>
    </h3>
    <div class="icon-close close one-line" (click)="close()" genericButton></div>
  }

  @if (!oneLineHeader) {
    <h3>{{ 'summary.receipt' | translate }}</h3>
    <p class="chargepoint">{{ chargePoint$()?.name }}</p>
    <div class="icon-close close" (click)="close()" genericButton></div>
  }
</div>

<div class="summary-container" [ngClass]="{ 'no-padding': noPadding }">
  <div class="section">
    <p class="title">{{ 'summary.receiptNumber' | translate }}</p>

    <p class="description">
      {{ station$()?.provider?.id ? station$().provider.id + ' / ' : ''
      }}{{ session$()?.receiptNumber }}
    </p>

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.bdrId' | translate }}</p>

    <p class="description">
      {{ session$()?.bdrId ? session$()?.bdrId : ('summary.pending' | translate) }}
    </p>

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.date' | translate }}</p>

    <p class="description">{{ sessionDate$() }}</p>

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.tariff' | translate }}</p>

    <p class="description">
      <app-tariff [tariff]="tariff$()" class="tariff" [hintIndicator]="false"></app-tariff>
    </p>

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.provider' | translate }}</p>

    <p class="description">{{ station$()?.provider.name }}</p>

    @if (session$()?.vatId) {
      <div style="clear: both"></div>
      <p class="description">{{ 'summary.vatId' | translate }}: {{ session$()?.vatId }}</p>
    }

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.location' | translate }}</p>

    <p class="description">{{ station$()?.address.street }}</p>

    <div style="clear: both"></div>

    <p class="description">{{ station$()?.address.zipCode }} {{ station$()?.address.city }}</p>

    <div style="clear: both"></div>
  </div>

  <div class="section">
    <p class="title">{{ 'summary.netPrice' | translate }}</p>

    <p class="description">{{ netPrice$() }}</p>

    <div style="clear: both"></div>
  </div>

  @if (showVat$()) {
    <div class="section">
      <p class="title">{{ ('summary.vat' | translate) + vatPercent$() }}</p>

      <p class="description">{{ vatAmount$() }}</p>

      <div style="clear: both"></div>
    </div>
  }

  <div class="section total">
    <p class="title">{{ 'summary.total' | translate }}</p>

    <p class="description">{{ grossPrice$() }}</p>

    <div style="clear: both"></div>
  </div>

  <div>
    <div class="disclaimer" [ngClass]="{ 'no-padding': noPadding }">
      {{ 'summary.disclaimer' | translate }}
    </div>

    @if (isStripe$()) {
      @if (!summaryReady$()) {
        <div class="summary-spinner">
          <mat-spinner [diameter]="32" [strokeWidth]="4" />
        </div>
      } @else if (errorMsg$()) {
        <p class="error-msg">{{ errorMsg$() | translate }}</p>
      } @else {
        <button
          branded
          class="button-filled-primary"
          [ngClass]="{ disabled: !receiptAvailable$() }"
          [disabled]="!receiptAvailable$()"
          (click)="savePDF()"
        >
          {{ 'summary.download' | translate }}
        </button>
      }
    } @else {
      @if (!summaryReady$()) {
        <div class="summary-spinner">
          <mat-spinner [diameter]="32" [strokeWidth]="4" />
        </div>
      } @else if (errorMsg$()) {
        <p class="error-msg">{{ errorMsg$() | translate }}</p>
      } @else {
        <div class="receipt-email-msg">
          <span>{{ 'summary.payone-receipt-email' | translate }}</span>
        </div>
      }
    }
  </div>
</div>
